import _ from 'lodash'
export default {
    props: {
        item: { type: Object },
        initialItem: { type: Object },
        mKey: { type: Number },
        services: {type: Object}
    },
    data() {
        return {
            classes: [
                { text: 'Class I', mapClass: 'CLASSI', value: '1', default_I: 3, default_II: 5},
                { text: 'Class II', mapClass: 'CLASSII', value: '2', default_I: 7, default_II: 10},
                { text: 'Class III', mapClass: 'CLASSIII', value: '3', default_I: 10, default_II: 15},
                { text: 'Not Yet Classified', mapClass: 'NOT_YET_CLASSIFIED', value: '4', default_I: 13, default_II: 20},
            ],
            oItem: [],
            orgType: '',
            classificationSettings: {
                '1': { isEnable: false, days: null }, // Class I
                '2': { isEnable: false, days: null }, // Class II
                '3': { isEnable: false, days: null }, // Class III
                '4': { isEnable: false, days: null }  // Not Yet Classified
            },
            oClassificationSettings: {},
            validationErrors: {
                '1': false,
                '2': false,
                '3': false,
                '4': false
            }
        }
    },
    watch: {
        classificationSettings: {
            handler(v, v_old) {
                if(Object.keys(this.oClassificationSettings).length == 0)
                {
                    this.oClassificationSettings = _.cloneDeep(this.classificationSettings)
                }
                this.$parent.hasUnsavedChanges = this.compareObjects(v, this.oClassificationSettings)
                // Clear validation errors when values change
                Object.keys(v).forEach(key => {
                    if (!v[key].isEnable) {
                        // Clear error if checkbox is unchecked
                        this.validationErrors[key] = false
                    } else if (v[key].days && v[key].days > 0) {
                        // Clear error if valid days value is entered
                        this.validationErrors[key] = false
                    }
                })
            },
            deep: true
        },
        mKey() {
            this.orgType = this.$store.state.organization.type
            this.$nextTick(()=>{
                // Initialize classification settings from item.recallDueDateConfiguration if it exists
                if (this.item.recallDueDateConfiguration && this.item.recallDueDateConfiguration.length > 0) {
                    this.item.recallDueDateConfiguration.forEach(setting => {
                        // Map classification names to keys
                        let classKey = null
                        if (setting.classification === 'CLASSI') {
                            classKey = '1'
                        } else if (setting.classification === 'CLASSII') {
                            classKey = '2'
                        } else if (setting.classification === 'CLASSIII') {
                            classKey = '3'
                        } else if (setting.classification === 'NOT_YET_CLASSIFIED') {
                            classKey = '4'
                        }
                        if (classKey && this.classificationSettings[classKey]) {
                            this.classificationSettings[classKey].isEnable = setting.isEnable === 1 || setting.isEnable === true
                            this.classificationSettings[classKey].days = setting.days || null
                        }
                    })
                }
            })
        }
    },
    methods: {
        validateDaysField() {
            let isValid = true
            Object.keys(this.classificationSettings).forEach(key => {
                if (this.classificationSettings[key].isEnable) {
                    const days = this.classificationSettings[key].days
                    if (!days || days === '' || days <= 0) {
                        this.validationErrors[key] = true
                        isValid = false
                    } else {
                        this.validationErrors[key] = false
                    }
                } else {
                    this.validationErrors[key] = false
                }
            })
            return isValid
        },
        save() {
            return new Promise((resolve, reject) => {
                if (!this.validateDaysField()) {
                    this.$noti.error('Please enter valid number of days for all enabled classifications.')
                    reject('Validation failed')
                    return
                }
                var payload = {
                    type: 'CONFIGUREDUEDATE',
                }
                if (this.orgType == 'PROVIDER') {
                    payload.class1_is_enabled = this.classificationSettings['1'].isEnable || false
                    payload.class1_days = this.classificationSettings['1'].isEnable ?
                        (parseInt(this.classificationSettings['1'].days) || 0) : 0
                    payload.class2_is_enabled = this.classificationSettings['2'].isEnable || false
                    payload.class2_days = this.classificationSettings['2'].isEnable ?
                        (parseInt(this.classificationSettings['2'].days) || 0) : 0
                    payload.class3_is_enabled = this.classificationSettings['3'].isEnable || false
                    payload.class3_days = this.classificationSettings['3'].isEnable ?
                        (parseInt(this.classificationSettings['3'].days) || 0) : 0
                    payload.class4_is_enabled = this.classificationSettings['4'].isEnable || false
                    payload.class4_days = this.classificationSettings['4'].isEnable ?
                        (parseInt(this.classificationSettings['4'].days) || 0) : 0
                }
                this.services.updateRecallDueDateConfiguration(payload).then(resp=>{
                    if (!resp.error) {
                        this.$emit('onCompleted')
                        resolve(resp)
                    } else {
                        reject(resp.error)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        compareObjects(obj1, obj2) {
            return JSON.stringify(obj1) !== JSON.stringify(obj2)
        },
        preventNegativeInput(classification, event) {
            let value
            if (typeof event === 'object' && event.target) {
                value = event.target.value
            } else if (typeof event === 'string' || typeof event === 'number') {
                value = event
            } else {
                value = this.classificationSettings[classification]?.days
            }
            if (value && (value.toString().includes('-') || value < 0)) {
                value = Math.abs(parseInt(value)) || 0
                this.classificationSettings[classification].days = value
                if (event && event.target) {
                    this.$nextTick(() => {
                        event.target.value = value
                    })
                }
            }
        },
        handleKeyDown(event) {
            if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
                event.preventDefault()
            }
        }
    }
}